// @ts-check

/** @file Defines the local Comment shell and associations. */

import CommentBase from "../model-bases/comment.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"
import {PROJECT_REPLICA_SYNC_DECLARATION} from "../database/project-replica-sync.js"

/** Comment row in the local application replica. */
const CommentModel = projectReplicaModel(CommentBase)

export default CommentModel

CommentModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
CommentModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
CommentModel.sync = PROJECT_REPLICA_SYNC_DECLARATION
CommentModel.belongsTo("resource", {polymorphic: true})
